

import React, { Component } from 'react';



import {
    Text,
    View,
    ScrollView,
    TouchableOpacity,
    Dimensions,
    Image,
    TextInput,
    ActivityIndicator,
    Linking,
    Keyboard,
    BackHandler,


} from 'react-native';




import { ListItem } from 'native-base';
import DrawerLayout from './DrawerLayout';

import * as Animatable from 'react-native-animatable';

import { MainColor, support, urls } from './Controller';
import { Icon, CheckBox, SocialIcon } from 'react-native-elements';

import {appstrings} from './translate/Strings';

import AsyncStorage from '@react-native-community/async-storage';

import Adventskalender from './Adventskalender';
import Ostereierschiessen from './Ostereierschiessen';

import MyWebView from './MyWebView.js';

//import Snow from './snow/Snow';

import {isIOS,isAndroid} from 'react-device-detect';
//isAndroid
//isIOS
//isMobile

import ReactGA from 'react-ga';





const uuid = require('react-native-uuid');

const adventskalenderMargin = 0;
const shadowColorDoor = '#000000';
const shadowColorDoorNr = '#000000';
//const imageUri = 'https://www.urlaubsgruss.com/crm/kalenderbild.jpg';
//const imageUri = 'https://www.urlaubsgruss.com/adventskalender-2020/spielregeln/COLOURBOX43745384_1200.jpg';
let imageUri = ['https://www.urlaubsgruss.com/adventskalender-2020/spielregeln/01.jpg',
                  'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/02.jpg',
                  'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/03.jpg',
                  'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/04.jpg',
                  'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/05.jpg',
                  'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/06.jpg'
                  ];

//let kalenderbild0 = {uri: 'https://www.urlaubsgruss.com/mobileapps2/legalfiles/adventskalender-bildertest/05.jpg'};
let kalenderbild = require('./images/2025_adventskalender.jpg');

const isPortrait = () => {
    const dim = Dimensions.get('screen');
    return dim.height >= dim.width;
};
//ADMIN-MODE

//googleAnalytics: false,
//isAdminMode: true,
//showAdventskalender: true,
//showStart: false,

//NORMAL

//googleAnalytics: true,
//isAdminMode: false,
//showAdventskalender: false,
//showStart: true,

let count = 0;
//let menufont = 'CaveatBrush-Regular';
//let menufont = 'Montserrat-Regular';
//let menufont = 'Montserrat-Medium';
//let menufont = 'Montserrat-Bold';
//let menufont = 'PTSerif-Bold';


//showTestModusBtn - BTN oben rechts - manipuliert den 24.12.
export default class Home extends Component {



constructor() {
        super();

        this.state = {

                showTestModusBtn: false,
                abfragenActiv: true,
                testmodus: false,
                testmodus_henni: false,
                heuteist: 18,
                googleAnalytics: false,
                isAdminMode: false,
                whatsapp: false,

                showAdventskalender: false,
                showOstereierschiessen: false,
                showStart: true,

                showStartEingabe: false,
                showBackgroundImage: true,
                showSnow: true,
                showStartAnimation: false,
                showFehler: false,

                showApplication: true,

                uuid: '',
                email: '',
                emailFail: false,

                teilnahmebedingungenCheck: false,
                teilnahmebedingungenCheckFail: false,
                newsletterCheck: false,

                showLoader: false,

                showWebView: false,
                myWebViewTitel: '',
                myWebViewUrl: '',
                myWebViewShowKontakt: false,
                deviceArt: 'pc',

                minWidthDialog: 0,

                isTablet: true,
                dimW: 0,
                dimH: 0,

                keyboard_visible: false,

                showHandyDrehen: false,

                gewinnText: '',
                gewinnGutscheincode: '',
                gewinnGutscheincodeHaltbarkeit: '',

                showErrorGewinnAbfrage: false,
                showNurEinmalProTag: false,

                showErstAbDezember: false,
                referrer: '',
                imageUri: imageUri[2],
                activeUri: 1,



        }


    }
/*
                gewinnText: '5 € Rabatt auf eine Bilderbox',
                gewinnGutscheincode: 'ak-xxxxxxxx',
                gewinnGutscheincodeHaltbarkeit: 'Der Gutscheincode kann nur 1 mal verwendet werden.\nEr ist gültig bis 31.12.2020',
*/


componentDidMount() {

        //alert(getUA)
//this.drawer.openDrawer();


        AsyncStorage.getItem('uuid').then((myuuid) => {

                if ( myuuid === null ){
                    let newuuid = uuid.v4();
                    this.setState({ uuid: newuuid, referrer: document.referrer});
                    AsyncStorage.setItem('uuid', newuuid);
                } else {
                    this.setState({ uuid: myuuid, referrer: document.referrer });
                }
        });

        BackHandler.addEventListener('hardwareBackPress', this.backPressed);
        Dimensions.addEventListener('change', this._onDimensionsChange.bind(this));

        if ( this.state.isAdminMode ){
            this.setState({ showBackgroundImage: false, showStart: false, showAdventskalender: true })
        }
        let orientation = isPortrait() ? 'portrait' : 'landscape';

        let isPC = true;

        if ( isIOS ){
            this.setState({ deviceArt: 'ios' });
            if ( orientation === 'landscape' ){
                    this.setState({ showHandyDrehen: true });
            }
            isPC = false;
        }
        if ( isAndroid ){
             this.setState({ deviceArt: 'android' });
             if ( orientation === 'landscape' ){
                    this.setState({ showHandyDrehen: true });
             }
             isPC = false;
        }

        if ( isPC ){

        }


        if ( this.state.googleAnalytics ){
            ReactGA.initialize('UA-55857252-7');
            ReactGA.pageview('Home');
        }
        //AsyncStorage.clear();

        //alert('window.screen.width:'+window.screen.width+'\nwindow.innerWidth:'+window.innerWidth+'\nDimensions.width:'+this.getScreenSize().width);
        //this.drawer.openDrawer();
}


sendDataToGoogle(kategorie,aktion){
if ( this.state.googleAnalytics ){
    ReactGA.event({
                      category: kategorie,
                      action: aktion
                    });
    }
}


start(){
if ( this.state.abfragenActiv ){
        this.setState({ showStartAnimation: true });

        //1.12.20 0:00 Uhr -> 1606777200
        //1.12.21 0:00 Uhr -> 1638313200
        //1.12.22 0:00 Uhr -> 1669849200
        //1.12.23 0:00 Uhr -> 1701385200
        //1.12.24 0:00 Uhr -> 1733007600
        //1.12.25 0:00 Uhr -> 1764543600
        //Thu Nov 17 2022 07:10:46 GMT+0000 -> 1668669046
        //Sun, 17 Nov 2024 10:00:00 +0100 -> 1731834000
        let dezember = 1764543600;

        if ( this.state.testmodus || this.state.testmodus_henni ){
            dezember = (Math.floor(Date.now())/1000)-1;
        }

        if ( Math.floor(Date.now())/1000 > dezember ){
        //if ( Math.floor(Date.now())/1000 > 1669849200 ){

            AsyncStorage.getItem('email').then((email) => {


                            if ( email !== null && email !== '' ){
                                this.setState({ email: email });
                                //Gewinnabfrage starten; Adventskalender starten
                                setTimeout(() => { this.startGewinnAbfrage(); }, 3000);
                            } else {

                                this.getEmail();

                            }
                            //alert(email)

            });

        } else {

            setTimeout(() => { this.setState({ showErstAbDezember: true }); }, 3000);

        }
}
}

componentWillUnmount() {
    Dimensions.removeEventListener('change', this._onDimensionsChange.bind(this));
    BackHandler.removeEventListener('hardwareBackPress', this.backPressed);

}



_onDimensionsChange(event) {
    //this.refs.Adventskalender.reset();
/*
    if ( this.getScreenSize().width === this.state.dimW && this.getScreenSize().height < this.state.dimH ){
        this.setState({ keyboard_visible: true });
        alert('Tastatur offen')
    } else {
        this.setState({ keyboard_visible: false });
        alert('Tastatur zu')
    }
*/

    //let orientation = isPortrait() ? 'portrait' : 'landscape';
//alert(orientation)


const { width, height } = event.window;
const isTablet = height < width;
        //if ( orientation === 'landscape' && this.state.deviceArt !== 'pc' ){
        if ( isTablet && this.state.deviceArt !== 'pc' ){
                this.setState({ showHandyDrehen: true });

        } else {
                this.setState({ showHandyDrehen: false });

                //this.setState({ isTablet: this.getScreenSize().isTablet, dimW: this.getScreenSize().width, dimH: this.getScreenSize().height });
            //this.setState({ showApplication: false, showAdventskalender: false, showLoader: true, isTablet: this.getScreenSize().isTablet, dimW: this.getScreenSize().width, dimH: this.getScreenSize().height });
            //setTimeout(() => { this.setState({ showApplication: true, showAdventskalender: true, showLoader: false }); }, 50);
        }


    if ( this.state.showStartEingabe === false || this.state.deviceArt === 'pc' ){
            this.setState({ showApplication: false, showAdventskalender: false, showLoader: true, isTablet: this.getScreenSize().isTablet, dimW: this.getScreenSize().width, dimH: this.getScreenSize().height });
            setTimeout(() => { this.setState({ showApplication: true, showAdventskalender: true, showLoader: false }); }, 50);
    }


}

backPressed = () => {
    //alert('test')
    return true;
}



getEmail(){


    this.setState({ isTablet: this.getScreenSize().isTablet, dimW: this.getScreenSize().width, dimH: this.getScreenSize().height });

    let xhttp = new XMLHttpRequest();

    xhttp.open('POST', urls.getEmail);
    xhttp.send();
    xhttp.onreadystatechange = () => {

                if (xhttp.readyState === XMLHttpRequest.DONE) {
                        //alert(JSON.stringify(xhttp.responseText));
                        let response = [];
                        if ( this.state.testmodus ){
                             response = {"email": "test@test.de"};
                        } else {
                             response = JSON.parse(xhttp.responseText);
                        }
                        //alert(JSON.stringify(response))
                        setTimeout(() => { this.setState({ email: response.email, showStartEingabe: true }); }, 3000);

                } else {
                        setTimeout(() => { this.setState({ email: '', showStartEingabe: true }); }, 3000);

                }

    }

}


startGewinnAbfrage(){

    this.setState({ showLoader: true });

    let xhttp = new XMLHttpRequest();

    let body = new FormData();
    body.append('email', this.state.email);
    body.append('uuid', this.state.uuid);
    body.append('ref', this.state.referrer);

    if ( this.state.newsletterCheck ){
        body.append('newsletter', this.state.newsletterCheck);
    }

    xhttp.open('POST', urls.getGewinn);
    xhttp.send(body);
    xhttp.onreadystatechange = () => {

                if (xhttp.readyState === XMLHttpRequest.DONE) {
                        //alert(JSON.stringify(xhttp.responseText));

                        let response = [];

                        if ( this.state.testmodus ){
                            response = {"text": "5 € Rabatt auf eine Bilderbox",
                                        "code": "ak-xxxxxxxx",
                                        "gueltig": "Der Gutscheincode kann nur 1 mal verwendet werden.\nEr ist gültig bis 31.12.2020",
                                        "error": 0};
                        } else {
                            response = JSON.parse(xhttp.responseText);
                        }
                        //alert(JSON.stringify(response));
                        //alert(xhttp.responseText);

                        if ( response.error === 0 ){
                                this.setState({

                                            gewinnText: response.text,
                                            gewinnGutscheincode: response.code,
                                            gewinnGutscheincodeHaltbarkeit: response.gueltig ,
                                            showStart: false,
                                            showAdventskalender: true,
                                            showStartEingabe: false

                                });
                                //alert(response.code);
                        }
                        if ( response.error === 1 ){
                               this.setState({ showErrorGewinnAbfrage: true, showLoader: false });
                               //alert('Fehler Code 1');

                        }
                        if ( response.error === 2 ){
                               this.setState({ showNurEinmalProTag: true, showLoader: false });
                               //alert('Fehler Code 2');
                               //alert(response.message);
                        }
                        //alert(this.state.referrer)
                        //setTimeout(() => { this.setState({ email: response.email, showStartEingabe: true }); }, 3000);

                } else {
                        //setTimeout(() => { this.setState({ email: '', showStartEingabe: true }); }, 3000);
                        //this.setState({ showErrorGewinnAbfrage: true });
                        //alert('Fehler');

                }

    }


//NUR ZUM TESTEN

//setTimeout(() => { this.setState({ showStart: false, showAdventskalender: true }); }, 3000);
}


gewinnPerEmailSenden(){

    let xhttp = new XMLHttpRequest();

    let body = new FormData();
    body.append('email', this.state.email);
    body.append('seccode', 'ef8b8df2-1a0f-4e47-9d41-7f00d72dd75c');
    body.append('gutscheininfo', this.state.gewinnText);
    body.append('code', this.state.gewinnGutscheincode);
    body.append('gutscheingueltigkeit', this.state.gewinnGutscheincodeHaltbarkeit);

    xhttp.open('POST', urls.sendEmail);
    xhttp.send(body);

}

Capitalize(str){
return str.charAt(0).toUpperCase() + str.slice(1);
}

validateEmail(email) {
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(email);
}

checkEmail(){

    if ( this.state.email !== '' && this.validateEmail(this.state.email) ){

        AsyncStorage.setItem('email', this.state.email);
                if ( this.state.teilnahmebedingungenCheck === false ){
                    this.setState({ teilnahmebedingungenCheckFail: true });
                } else {
                    //Gewinnabfrage starten; Adventskalender starten
                    this.startGewinnAbfrage();

                }

    } else {
        this.setState({ emailFail: true, email: '' });
        if ( this.state.teilnahmebedingungenCheck === false ){
            this.setState({ teilnahmebedingungenCheckFail: true });
        }
    }
}



getTimeStamp(){
    return Math.floor(Date.now() / 1000);
}


deleteDataAndRestart(){

    if ( this.state.keyboard_visible ){
            Keyboard.dismiss();
    } else {
    AsyncStorage.setItem('email', '').then((email) => {
                this.setState({ showApplication: false, showAdventskalender: false, showLoader: false, showStart: false, showStartEingabe:false, emailFail: false, teilnahmebedingungenCheck: false, teilnahmebedingungenCheckFail: false, newsletterCheck: false, email: '' });
                setTimeout(() => { this.setState({ showApplication: true, showStart: true }); this.start(); }, 50);

            });
    }
    //alert(this.state.keyboard_visible)
}

menuaction(action){

 this.drawer.closeDrawer();

setTimeout(() => {

    if ( action === 'logout' ){
        this.deleteDataAndRestart();
    }

    if ( action === 'login' ){

    }


    if ( action === 'empfehlen' ){
            Linking.openURL('whatsapp://send?text='+appstrings().strings.empfehlenText).catch(err => this.setState({showFehler:true}));
    }



    if ( action === 'teilnahmebedingungen' ){
            this.setState({myWebViewTitel:appstrings().strings.teilnahmebedingungen, myWebViewUrl:urls.teilnahmebedingungen, myWebViewShowKontakt: false, showWebView:true, });
            this.sendDataToGoogle('User','Teilnahmebedingungen geöffnet');
    }

    if ( action === 'impressum' ){
            this.setState({myWebViewTitel:appstrings().strings.impressum, myWebViewUrl:urls.impressum, myWebViewShowKontakt: false, showWebView:true, });
    }

    if ( action === 'datenschutz' ){
            this.setState({myWebViewTitel:appstrings().strings.datenschutz, myWebViewUrl:urls.datenschutz, myWebViewShowKontakt: false, showWebView:true, });
    }

    if ( action === "Agb" ){
            this.setState({myWebViewTitel:appstrings().strings.agb, myWebViewUrl:urls.agb, myWebViewShowKontakt: false, showWebView:true, });
    }

    if ( action === 'support' ){

                   let mail = support.mail;
                   let subject = support.appname+' '+support.device+' '+support.version;
                   //let message = appstrings().strings.support1+support.appname+'-Team,\n\n'+appstrings().strings.support4;
                   //let url = 'mailto:'+support.mail+'?cc=&subject='+subject+'&body='+message;
                   let url = 'mailto:'+mail+'?cc=&subject='+subject;
                   Linking.openURL(url);

    }

    if ( action === 'ugweb' ){

            if ( this.state.deviceArt === 'pc' ){
                window.open(urls.urlaubsgruss, "_blank");
            } else {
                Linking.openURL('urlaubsgruss://').catch(() => {
                         window.open(urls.urlaubsgruss, "_blank");
                });
            }
            this.sendDataToGoogle('User','Startseite geöffnet');
    }

    if ( action === 'kartendesigns' ){
            window.open(urls.urlaubsgrussMotive, "_blank");
            this.sendDataToGoogle('User','Kartendesigns geöffnet');
    }
        if ( action === "Facebook" ){

            if ( this.state.deviceArt === 'ios' ){
                Linking.openURL('fb://profile/193079267403934').catch(() => {
                     window.open(urls.facebook, "_blank");
                });
            }

            if ( this.state.deviceArt === 'android' ){
                Linking.openURL('fb://page/193079267403934').catch(() => {
                     window.open(urls.facebook, "_blank");
                });
            }

            if ( this.state.deviceArt === 'pc' ){
                window.open(urls.facebook, "_blank");
            }
            this.sendDataToGoogle('User','Facebook geöffnet');
        }
        if ( action === "Instagram" ){

            if ( this.state.deviceArt === 'pc' ){
                    window.open(urls.instagram, "_blank");
            } else {
                Linking.openURL('instagram://user?username=urlaubsgruss').catch(() => {
                    window.open(urls.instagram, "_blank");
                });
            }
            this.sendDataToGoogle('User','Instagram geöffnet');
        }

        if ( action === "Youtube" ){
                window.open(urls.youtube, "_blank")
        }

        if ( action === "twitter" ){
                window.open(urls.twitter, "_blank")
        }

}, 500);
};




getScreenSize(){
    let w = Dimensions.get('window').width;
    let h = Dimensions.get('window').height;


    let isTablet = true;
    if ( h > w ){
        isTablet = false;

        if ( w > window.screen.width ){
            w = window.screen.width;
            h = window.screen.height-150;
        }

    }
    if ( this.state.showStartEingabe && this.state.deviceArt !== 'pc'){
        isTablet = this.state.isTablet;
        w = this.state.dimW;
        h = this.state.dimH;
    }

    return { width: w, height: h, isTablet:isTablet };
}

getDrawerWidth(){
    var drawerWidth = this.getScreenSize().width/5*4;
    if ( this.getScreenSize().isTablet ){
        drawerWidth = this.getScreenSize().width/5*1.5;
    }
    return drawerWidth;
}

getDrawerHeight(){
    var drawerLogoheight = this.getScreenSize().height/5;

    return drawerLogoheight;
}

getDrawerLogoHeight(){
    var drawerLogoHeight = (this.getDrawerWidth()/5*3)/1.85;
    if ( this.getScreenSize().isTablet ){
        drawerLogoHeight = (this.getDrawerWidth()/5*3)/1.85;;
    }
    return drawerLogoHeight;
}


deleteAllBrowserData(){

    if ( count === 30 ){
        AsyncStorage.clear();
        alert('Daten wurden gelöscht!');
    }
    count++;
}


getToday(){

    let date = new Date();
    let day = date.getDate();
    if ( this.state.testmodus || this.state.testmodus_henni ){
        day = this.state.heuteist;
    }
    return day;
}






  render() {



let navigationView = (
      <View style={{flex: 1, backgroundColor:'#ffffff'}}>

<ScrollView>
    <View style={{ width: this.getDrawerWidth(), height: this.getDrawerHeight() }}>
      <Image style={{position:'absolute', top:0, width: '100%', height: '100%'}} resizeMode="stretch" source={require("./images/schnee.jpg")} />
      <Image style={{ alignSelf:'center', width: this.getDrawerWidth()/2, height: this.getDrawerLogoHeight(), margin: 0,}} resizeMode="contain" source={require("./images/ug_logo_xmas_dunkel.png")} />
</View>
{ this.state.email !== '' ?
<View style={{ marginLeft:20, marginBottom: 25, marginTop: 10 }}>
    <Text style={{ color:MainColor.text, fontSize:this.getScreenSize().isTablet?18:14, fontFamily:'Montserrat-Bold' }}>{appstrings().strings.angemeldetals}</Text>
<Text style={{ fontFamily:'Montserrat-Regular', color:MainColor.text, fontSize:this.getScreenSize().isTablet?14:12 }}>{this.state.email}</Text>
</View>:null
}



                              <ListItem itemDivider >
                                <Text style={{ fontFamily:'Montserrat-Bold', color:MainColor.primary, fontSize:this.getScreenSize().isTablet?24:20,  marginLeft: 0 }}>{appstrings().strings.menu}</Text>
                                <TouchableOpacity onPress={()=>{this.drawer.closeDrawer()}}
                                          style={{ backgroundColor:MainColor.primary, borderRadius: 15, position: 'absolute', right:25, borderWidth:0, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.25 }}>
                                          <Text style={{fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?14:10, color:'#ffffff', padding:5, paddingLeft:10, paddingRight:10}}>{appstrings().strings.close}</Text>
                                </TouchableOpacity>
                              </ListItem>

{ this.state.deviceArt === 'pc' ?
                              <ListItem onPress={() => this.menuaction('kartendesigns')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='pine-tree' type='material-community' color={'#b80c0c'}/>
                                  <Text style={{ position:'absolute', left: this.getScreenSize().isTablet?60:45, color:'#b80c0c', fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.kartendesigns}</Text>
                             </ListItem>:null
}

                              <ListItem onPress={() => this.menuaction('ugweb')}>
                                  { this.state.deviceArt === 'pc' ?
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='home' type='font-awesome' color={MainColor.text}/>:null
                                  }
                                  { this.state.deviceArt === 'ios' ?
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='apple' type='material-community' color={MainColor.text}/>:null
                                  }
                                  { this.state.deviceArt === 'android' ?
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='android' type='font-awesome' color={MainColor.text}/>:null
                                  }
                                  <Text style={{position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{this.state.deviceArt==='pc'?appstrings().strings.ugweb:appstrings().strings.ugapp}</Text>
                             </ListItem>

                              <ListItem onPress={() => this.menuaction('teilnahmebedingungen')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='life-ring' type='font-awesome' color={MainColor.text}/>
                                  <Text style={{ position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.teilnahmebedingungen}</Text>
                             </ListItem>

                              <ListItem onPress={() => this.menuaction('empfehlen')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='heart' type='font-awesome' color={MainColor.text}/>
                                  <Text style={{ position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.empfehlen}</Text>
                             </ListItem>

                              <ListItem onPress={() => this.menuaction('support')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='envelope' type='font-awesome' color={MainColor.text}/>
                                  <Text style={{position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.support}</Text>
                             </ListItem>

                              <ListItem onPress={() => this.menuaction('impressum')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='info-circle' type='font-awesome' color={MainColor.text}/>
                                  <Text style={{position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.impressum}</Text>
                             </ListItem>

                              <ListItem onPress={() => this.menuaction('datenschutz')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='lock' type='font-awesome' color={MainColor.text}/>
                                  <Text style={{position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{appstrings().strings.datenschutz}</Text>
                             </ListItem>


                              <ListItem onPress={() => this.menuaction('logout')}>
                                  <Icon size={this.getScreenSize().isTablet?28:20} name='account' type='material-community' color={MainColor.text}/>
                                  <Text style={{position:'absolute', left: this.getScreenSize().isTablet?60:45, color:MainColor.text, fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:16 }}>{this.state.email===''?appstrings().strings.login:appstrings().strings.logout}</Text>
                             </ListItem>

                                        <ListItem style={{justifyContent:'center'}}>
                                                <SocialIcon
                                                style={{ borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                  onPress={()=>this.menuaction('Facebook')}
                                                  type='facebook'
                                                />

                                                <SocialIcon
                                                style={{ borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                  onPress={()=>this.menuaction('Instagram')}
                                                  type='instagram'
                                                />

                                                <SocialIcon
                                                style={{ borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                  onPress={()=>this.menuaction('twitter')}
                                                  type='twitter'
                                                />
{ this.state.whatsapp ?
                                                <SocialIcon
                                                style={{ backgroundColor:'#25D366', borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                  onPress={()=>this.menuaction('empfehlen')}
                                                  type='whatsapp'
                                                />:null
}

                                        </ListItem>


                              <ListItem itemDivider onPress={ ()=> this.deleteAllBrowserData() } style={{justifyContent:'flex-end', alignItems:'center'}}>
                                 <Icon size={16} name='copyright' type='font-awesome' color={MainColor.text}/>
                                 <Text style={{color:MainColor.text, marginLeft:10, marginRight:10, fontSize:this.getScreenSize().isTablet?14:12, fontFamily:'Montserrat-Bold' }}>{support.appname+' '+support.version}</Text>

                             </ListItem>


        </ScrollView>
      </View>
);






    return (

    <>
      <style type="text/css">{`
        @font-face {
          font-family: 'FontAwesome';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'MaterialCommunityIcons';
          src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Lovers Quarrel';
          src: url(${require('./fonts/Lovers Quarrel.otf')}) format('opentype');
        }
        @font-face {
          font-family: 'CaveatBrush-Regular';
          src: url(${require('./fonts/CaveatBrush.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Regular';
          src: url(${require('./fonts/Montserrat-Regular.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Medium';
          src: url(${require('./fonts/Montserrat-Medium.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Bold';
          src: url(${require('./fonts/Montserrat-Bold.ttf')}) format('truetype');
        }
      `}</style>


<DrawerLayout
      drawerWidth={this.getDrawerWidth()}
      ref={(_drawer) => this.drawer = _drawer}
      drawerPosition={DrawerLayout.positions.Left}
      onDrawerClose={() => this.setState({isDrawerOpen: false })}
      onDrawerOpen={() => this.setState({isDrawerOpen: true }) }
      renderNavigationView={() => navigationView }
      deviceWidth={this.getScreenSize().width}
      >

{ this.state.showApplication ?
        <View style={{ width:this.getScreenSize().width, height:this.getScreenSize().height, backgroundColor:MainColor.primary}}>

         <TouchableOpacity style={{ width:50, height:50, position:'absolute', left:0, zIndex:99999, justifyContent:'center'}} onPress={()=>this.drawer.openDrawer() }>
             <Icon  size={40} name='menu' type='material-community' color='#ffffff'/>
         </TouchableOpacity>


{
this.state.showAdventskalender ?
<View style={{ width: this.getScreenSize().width, height:this.getScreenSize().height, top:0, left:0, position:'absolute', backgroundColor:'#ffffff' }}>
<View style={{ width: this.getScreenSize().width-adventskalenderMargin, height:this.getScreenSize().height-adventskalenderMargin, top:adventskalenderMargin/2, left:adventskalenderMargin/2, position:'absolute', backgroundColor:'#ffffff',shadowColor: '#000000', shadowOffset: { width: 0, height: 0 }, shadowRadius: 10, shadowOpacity: 0.5 }}>
<Adventskalender
        ref={'Adventskalender'}
        width={this.getScreenSize().width-adventskalenderMargin}
        height={this.getScreenSize().height-adventskalenderMargin}
        doorNrSize={this.getScreenSize().isTablet?36:24}
        imageuri={this.state.imageUri}
        source={kalenderbild}
        todayIs={Number.parseInt(this.getToday())}
        shadowColorDoor={shadowColorDoor}
        shadowColorDoorNr={shadowColorDoorNr}
        gewinnText={this.state.gewinnText}
        gewinnGutscheincode={this.state.gewinnGutscheincode}
        gewinnGutscheincodeHaltbarkeit={this.state.gewinnGutscheincodeHaltbarkeit}
        showLoader={(bol)=>this.setState({ showLoader: bol })}
        isAdminMode={this.state.isAdminMode}
        googleAnalytics={this.state.googleAnalytics}
        deviceArt={this.state.deviceArt}
        gewinnPerEmailSenden={()=>this.gewinnPerEmailSenden()}
        >
</Adventskalender>
</View></View>:null
}



</View>:null
}

{ this.state.showSnow ?
<View pointerEvents={'none'} style={{ zIndex:9999, width:this.getScreenSize().width, height:this.getScreenSize().height, position:'absolute', }}>

</View>:null
}

{ this.state.showStart ?

<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, alignItems:'center', justifyContent:'center', backgroundColor:MainColor.starthintergrund }}>

{ this.state.showBackgroundImage ?
<Image style={{ position: 'absolute', top: 0, width: this.getScreenSize().width, height:this.getScreenSize().height,  }}
                resizeMode="cover" source={this.getScreenSize().isTablet?require("./images/2025_hintergrund.jpg"):require("./images/2025_hintergrund_hoch.jpg")} onLoad={()=>this.start()} />:null
}


{ this.state.showStartAnimation ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, alignItems:'center', justifyContent:'center',  }}>
<Animatable.Image animation="bounceIn" style={this.getScreenSize().isTablet?{ zIndex:999, position: 'absolute', bottom:25, left:25, width: this.getScreenSize().isTablet?this.getScreenSize().height/4:this.getScreenSize().width/2, height:this.getScreenSize().isTablet?this.getScreenSize().height/4/1.85:this.getScreenSize().width/2/1.85, opacity:1,  }:{ zIndex:999, position: 'absolute', bottom:25, width: this.getScreenSize().isTablet?this.getScreenSize().height/4:this.getScreenSize().width/2, height:this.getScreenSize().isTablet?this.getScreenSize().height/4/1.85:this.getScreenSize().width/2/1.85, opacity:1,  }}
                 resizeMode="contain" source={require("./images/ug_logo_xmas_hell.png")} />

<Animatable.Image animation="slideInLeft" style={{ position: 'absolute', top: 0, width: this.getScreenSize().width, height:this.getScreenSize().height,  }}
                 resizeMode="cover" source={this.getScreenSize().isTablet?require("./images/2025_aufhaenger.png"):require("./images/2025_aufhaenger_hoch.png")} />
<Animatable.Image  style={{ position: 'absolute', top: 0, width: this.getScreenSize().width, height:this.getScreenSize().height,  }}
                 resizeMode="cover" source={this.getScreenSize().isTablet?require("./images/2025_wolke.png"):require("./images/2025_wolke_hoch.png")} />
<Animatable.Image  style={{ position: 'absolute', top: 0, width: this.getScreenSize().width, height:this.getScreenSize().height,  }}
                 resizeMode="cover" source={this.getScreenSize().isTablet?require("./images/2025_schriftzug.png"):require("./images/2025_schriftzug_hoch.png")} />

{ this.state.showAnimatedText ?
<View>
<Animatable.Text animation="slideInDown" style={{ fontSize: this.getScreenSize().isTablet?140:this.getScreenSize().width/8, color:'#ffffff', fontFamily:'Lovers Quarrel' }}>{appstrings().strings.adventskalender}</Animatable.Text>
<Animatable.Text animation="slideInRight" style={{ fontFamily:'Montserrat-Medium', fontSize: this.getScreenSize().isTablet?100:this.getScreenSize().width/8, color:'#ffffff' }}>{appstrings().strings.jahr}</Animatable.Text>
</View>:null
}

        <TouchableOpacity style={{ position:'absolute', top:0, left: 0, width:50, height: 50, alignItems:'center', justifyContent:'center' }}
            onPress={() => { this.drawer.openDrawer(); }}>
            <Icon size={36} name='menu' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>

</View>:null
}

{ this.state.showStartEingabe ?
    <Animatable.View ref={'aktionsDialog'} animation="bounceIn" style={{ zIndex: 9, minWidth: this.state.minWidthDialog, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:'#ffffff', borderRadius:40, borderWidth:4, borderColor:'#ffffff',
                                                shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onLayout={(event) => { this.setState({ minWidthDialog: event.nativeEvent.layout.width }) }}>

        <View style={{ padding:30, borderRadius:25, borderWidth:4, borderColor:'#ffffff' }}>

        <Text style={{ paddingTop:10, fontSize:this.getScreenSize().isTablet?24:20, width:'100%', textAlign:'center', fontFamily:'Montserrat-Medium', color:MainColor.text }}>{appstrings().strings.emaileingeben}</Text>

        <TextInput style={{ outlineWidth: 0, width:'80%', fontFamily:'Montserrat-Medium', fontSize:this.getScreenSize().isTablet?18:14, textAlignVertical: 'top', padding:10, backgroundColor: MainColor.texteditback, marginBottom:0, marginTop:30,
                     color:MainColor.text, textAlign:'center', borderRadius: 15, borderWidth: 2, borderColor: MainColor.borderColor, alignSelf:'center',
                      shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.25 }}
             value={this.state.email}
             placeholder={appstrings().strings.email}
             placeholderTextColor={MainColor.plholder}
             keyboardType={'email-address'}
             selectionColor={MainColor.primary}
             multiline = {false}
             returnKeyType={'default'}
             onFocus ={()=>{ this.setState({ emailFail: false }) }}
             underlineColorAndroid  = 'transparent'
             onSubmitEditing={() => Keyboard.dismiss() }
             onChangeText={(text) => this.setState({ email: text }) }
             blurOnSubmit={false}
        />


<Text style={{ alignSelf:'center', fontSize:this.getScreenSize().isTablet?16:12, textAlign:'center', color:MainColor.signal, marginTop:5, marginBottom:20,  }}>{this.state.emailFail?appstrings().strings.emailFail:' '}</Text>

            <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center' }}>
                  <CheckBox
                    left
                    size={40}
                    containerStyle={{backgroundColor:'#ffffff', width: 50, padding: 5, borderColor:'#ffffff', borderRadius:10}}
                    iconType='material-community'
                    checkedIcon='checkbox-marked-circle'
                    uncheckedIcon='checkbox-blank-circle-outline'
                    checkedColor={MainColor.green}
                    uncheckedColor={this.state.teilnahmebedingungenCheckFail?MainColor.signal:MainColor.primary}
                    checked={this.state.teilnahmebedingungenCheck}
                    onPress={() => { this.setState({ teilnahmebedingungenCheck:!this.state.teilnahmebedingungenCheck, teilnahmebedingungenCheckFail: false }) }}
                  />
                  <Text style={{ fontFamily:'Montserrat-Medium', paddingLeft:5, color:this.state.teilnahmebedingungenCheckFail?MainColor.signal:MainColor.text, fontSize: this.getScreenSize().isTablet?18:16  }}>{appstrings().strings.teilnahmebedingungencheck1+' '}{<Text onPress={()=>this.menuaction('teilnahmebedingungen')} style={{ textDecorationLine: 'underline', color:this.state.teilnahmebedingungenCheckFail?MainColor.text:MainColor.signal  }}>{appstrings().strings.teilnahmebedingungen}</Text>}{' '+appstrings().strings.teilnahmebedingungencheck2}</Text>
            </View>

            <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', marginTop:20, marginBottom:30 }}>
                  <CheckBox
                    left
                    size={40}
                    containerStyle={{backgroundColor:'#ffffff', width: 50, padding: 5, borderColor:'#ffffff', borderRadius:10}}
                    iconType='material-community'
                    checkedIcon='checkbox-marked-circle'
                    uncheckedIcon='checkbox-blank-circle-outline'
                    checkedColor={MainColor.green}
                    uncheckedColor={MainColor.primary}
                    checked={this.state.newsletterCheck}
                    onPress={() => { this.setState({ newsletterCheck:!this.state.newsletterCheck }) }}
                  />
                  <Text style={{ fontFamily:'Montserrat-Medium', paddingLeft:5, color:MainColor.text, fontSize: this.getScreenSize().isTablet?18:16  }}>{appstrings().strings.newslettercheck}</Text>
            </View>


        <TouchableOpacity style={{ position:'absolute', top:-25, right:-25, backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.deleteDataAndRestart(); }}>
            <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>

        <TouchableOpacity style={{ backgroundColor:MainColor.primary, borderRadius:25, width:this.getScreenSize().isTablet?'70%':'90%', alignSelf:'center', height: 50, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center',
                                   flexDirection:'row', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.2 }}
            onPress={() => { this.checkEmail(); }}>
            <Text style={{ fontSize:this.getScreenSize().isTablet?20:16, textAlign:'left', fontFamily:'Montserrat-Bold', color:'#ffffff' }}>{appstrings().strings.weiterzuadvent}</Text>
        </TouchableOpacity>



    </View>
    </Animatable.View>:null
}




</View>:null
}


{ this.state.showErrorGewinnAbfrage ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, zIndex:99999, justifyContent:'center', alignItems:'center', backgroundColor:'#00000099' }}>
    <Animatable.View ref={'showErrorGewinnAbfrage'} animation="bounceIn" style={{ zIndex: 99, minWidth: this.state.minWidthDialog, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:'#ffffff', borderRadius:15, borderWidth:4, borderColor:'#ffffff',
                                                shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            >
        <View style={{ padding:30, borderRadius:15, borderWidth:2, borderColor:MainColor.text }}>

        <Text style={{ padding:30, fontSize:this.getScreenSize().isTablet?20:16, width:'100%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{appstrings().strings.fehlerbeiabfrage}</Text>



        <TouchableOpacity style={{ position:'absolute', top:-25, right:-25, backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.setState({ showErrorGewinnAbfrage: false }); }}>
            <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>


    </View>
    </Animatable.View></View>:null
}

{ this.state.showNurEinmalProTag ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, zIndex:99999, justifyContent:'center', alignItems:'center', backgroundColor:'#00000099' }}>
    <Animatable.View ref={'showNurEinmalProTag'} animation="bounceIn" style={{ zIndex: 99, minWidth: this.state.minWidthDialog, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:'#ffffff', borderRadius:15, borderWidth:4, borderColor:'#ffffff',
                                                shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            >
        <View style={{ padding:30, borderRadius:15, borderWidth:2, borderColor:MainColor.text }}>

        <Text style={{ padding:30, fontSize:this.getScreenSize().isTablet?20:16, width:'100%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{appstrings().strings.nureinmalprotag}</Text>



        <TouchableOpacity style={{ position:'absolute', top:-25, right:-25, backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.setState({ showNurEinmalProTag: false }); }}>
            <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>


    </View>
    </Animatable.View></View>:null
}

{ this.state.showErstAbDezember ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, zIndex:99999, justifyContent:'center', alignItems:'center', backgroundColor:'#00000099' }}>
    <Animatable.View ref={'showErstAbDezember'} animation="bounceIn" style={{ zIndex: 99, minWidth: this.state.minWidthDialog, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:'#ffffff', borderRadius:15, borderWidth:4, borderColor:'#ffffff',
                                                shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
        >
        <View style={{ padding:30, borderRadius:15, borderWidth:3, borderColor:MainColor.primary }}>


        <Text style={{ fontFamily:'Montserrat-Medium', padding:30, fontSize:this.getScreenSize().isTablet?20:16, width:'100%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{appstrings().strings.erstabdezember}</Text>



        <TouchableOpacity style={{ position:'absolute', top:-25, right:-25, backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.setState({ showErstAbDezember: false }); }}>
            <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>


    </View>
    </Animatable.View></View>:null
}

{
this.state.showWebView ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, zIndex:99999, justifyContent:'center', alignItems:'center'}}>
<MyWebView
close={()=>this.setState({showWebView:false})}
titel={this.state.myWebViewTitel}
url={this.state.myWebViewUrl}
showKontakt={this.state.myWebViewShowKontakt}
>
</MyWebView>
</View>:null
}

{
this.state.showHandyDrehen ?
<View style={{position:'absolute', width:this.getScreenSize().isTablet?this.getScreenSize().width:this.getScreenSize().height, height: this.getScreenSize().isTablet?this.getScreenSize().height:this.getScreenSize().width, zIndex:99999, justifyContent:'center', alignItems:'center', backgroundColor:'#ffffff'}}>

<Icon size={48} reverse raised name='phone-rotate-portrait' type='material-community' color={MainColor.primary}  />
<Text style={{ marginLeft:40, marginRight:40, marginTop:20, fontSize:12, fontWeight:'bold', color:MainColor.primary, textAlign:'center'}}>{appstrings().strings.handydrehen}</Text>
</View>:null
}


{ this.state.showLoader ?
<View style={{ zIndex: 999999, backgroundColor:'#ffffff99', position:'absolute', width: this.getScreenSize().width, height: this.getScreenSize().height, alignItems:'center', justifyContent:'center' }}>
<ActivityIndicator style={{ transform:[{scale:2}]}} size="large" color={MainColor.signal} />
</View>:null
}

{ this.state.showFehler ?
<View style={{ position:'absolute', top: 0, width:this.getScreenSize().width, height:this.getScreenSize().height, zIndex:99999, justifyContent:'center', alignItems:'center', backgroundColor:'#00000099' }}>
    <Animatable.View ref={'showFehler'} animation="bounceIn" style={{ zIndex: 99, minWidth: this.state.minWidthDialog, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:'#ffffff', borderRadius:15, borderWidth:4, borderColor:'#ffffff',
                                                shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
        >
        <View style={{ padding:30, borderRadius:15, borderWidth:2, borderColor:MainColor.text }}>


        <Text style={{ padding:30, fontSize:this.getScreenSize().isTablet?20:16, width:'100%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{appstrings().strings.teilenfehler}</Text>



        <TouchableOpacity style={{ position:'absolute', top:-25, right:-25, backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.setState({ showFehler: false }); }}>
            <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
        </TouchableOpacity>


    </View>
    </Animatable.View></View>:null
}


{
this.state.showTestModusBtn ?
        <TouchableOpacity style={{ position:'absolute', top:5, right:5, width: 20, height:20, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity:0.5 }}
            onPress={() => { this.setState({ testmodus: true }); setTimeout(() => { this.deleteDataAndRestart(); }, 50); }}>

        </TouchableOpacity>:null
}


{
this.state.showOstereierschiessen ?
<View style={{ width: this.getScreenSize().width, height:this.getScreenSize().height, top:0, left:0, position:'absolute', backgroundColor:'#ffffff' }}>
<View style={{ width: this.getScreenSize().width-adventskalenderMargin, height:this.getScreenSize().height-adventskalenderMargin, top:adventskalenderMargin/2, left:adventskalenderMargin/2, position:'absolute', backgroundColor:'#ffffff',shadowColor: '#000000', shadowOffset: { width: 0, height: 0 }, shadowRadius: 10, shadowOpacity: 0.5 }}>
<Ostereierschiessen
        ref={'Adventskalender'}
        width={this.getScreenSize().width-adventskalenderMargin}
        height={this.getScreenSize().height-adventskalenderMargin}
        doorNrSize={this.getScreenSize().isTablet?36:24}
        imageuri={this.state.imageUri}
        source={kalenderbild}
        todayIs={Number.parseInt(this.getToday())}
        shadowColorDoor={shadowColorDoor}
        shadowColorDoorNr={shadowColorDoorNr}
        gewinnText={this.state.gewinnText}
        gewinnGutscheincode={this.state.gewinnGutscheincode}
        gewinnGutscheincodeHaltbarkeit={this.state.gewinnGutscheincodeHaltbarkeit}
        showLoader={(bol)=>this.setState({ showLoader: bol })}
        isAdminMode={this.state.isAdminMode}
        googleAnalytics={this.state.googleAnalytics}
        deviceArt={this.state.deviceArt}
        gewinnPerEmailSenden={()=>this.gewinnPerEmailSenden()}
        >
</Ostereierschiessen>
</View></View>:null
}


</DrawerLayout>

</>
    );
  }
}

/*

//test für Instagram-In-App-Browser
<Text style={{ position:'absolute', bottom: 25, left: 25 }}>{'window.screen.width:'+window.screen.width+'\nwindow.innerWidth:'+window.innerWidth+'\nDimensions.width:'+this.getScreenSize().width}</Text>


                  <CheckBox
                    left
                    size={40}
                    title={appstrings().strings.teilnahmebedingungencheck}
                    textStyle={{color:this.state.teilnahmebedingungenCheckFail?MainColor.signal:MainColor.text, fontSize: this.getScreenSize().isTablet?16:14}}
                    checkedTitle={appstrings().strings.teilnahmebedingungencheck}
                    containerStyle={{backgroundColor:'#ffffff', borderColor:'#ffffff', borderRadius:10}}
                    iconType='material-community'
                    checkedIcon='checkbox-marked-circle'
                    uncheckedIcon='checkbox-blank-circle-outline'
                    checkedColor={MainColor.green}
                    uncheckedColor={this.state.teilnahmebedingungenCheckFail?MainColor.signal:MainColor.text}
                    checked={this.state.teilnahmebedingungenCheck}
                    onPress={() => { this.setState({ teilnahmebedingungenCheck:!this.state.teilnahmebedingungenCheck, teilnahmebedingungenCheckFail: false }) }}
                  />

                  <CheckBox
                    left
                    size={40}
                    title={appstrings().strings.newslettercheck}
                    textStyle={{color:MainColor.text, fontSize: this.getScreenSize().isTablet?16:14}}
                    checkedTitle={appstrings().strings.newslettercheck}
                    containerStyle={{backgroundColor:'#ffffff', borderColor:'#ffffff', borderRadius:10}}
                    iconType='material-community'
                    checkedIcon='checkbox-marked-circle'
                    uncheckedIcon='checkbox-blank-circle-outline'
                    checkedColor={MainColor.green}
                    uncheckedColor={MainColor.text}
                    checked={this.state.newsletterCheck}
                    onPress={() => { this.setState({ newsletterCheck:!this.state.newsletterCheck }) }}
                  />
                  */